// A reference-list config value is stored as a JSON array string of ids (e.g. ["a","b"]),
// so it flows through the generic string-based config-save path unchanged.
export function parseIds(raw: unknown): string[] {
  if (typeof raw !== "string" || raw.trim() === "") return [];
  try {
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed)
      ? parsed.filter((v): v is string => typeof v === "string")
      : [];
  } catch {
    return [];
  }
}

// Empty selection is stored as "" (not "[]") so the config-save path treats it as unset.
export function serializeIds(ids: string[]): string {
  return ids.length > 0 ? JSON.stringify(ids) : "";
}
